module.exports = __webpack_public_path__ + "img/lite_ground.ba90f381.png";